/*
 * @Author: Shusheng
 * @Date: 2024-08-18 10:29:23
 * @LastEditors: Shusheng
 * @Description: 线上环境配置
 */
import { isXwsy, isXwx, isXwyk } from '../env';
const XwxConfig = {
  appid: 'A269346936',
  haichuanDomain: 'https://xuefuta.xue.xiwang.com/',
  // 学业诊断报告链接
  diagnosticReportHost: 'https://knowledge.xiwang.com/school-diagnose/#/DiagnosisReport',
  // 学业诊断报告-编辑页面
  diagnosticReportEditHost: 'https://knowledge.xiwang.com/#/schoolDiagnose',
  // 导出pdf服务
  exportPdfDomain: 'https://pdf-export.xue.xiwang.com/',
  // 公告链接
  gongGaoJsonUrl:
    'https://m.xiwang.com/resource/__private__/4f229bfbfc600c39aa9811e209265b72/%E6%95%99%E5%B8%88%E5%B7%A5%E4%BD%9C%E5%8F%B0%E5%85%AC%E5%91%8A%E6%A0%8F.json'
};

const XwsyConfig = {
  appid: 'A269346936',
  haichuanDomain: 'https://xuefuta.xue.xiwang.com/',
  // 学业诊断报告链接
  diagnosticReportHost: 'https://knowledge.xiwang.com/school-diagnose/#/DiagnosisReport',
  // 学业诊断报告-编辑页面
  diagnosticReportEditHost: 'https://knowledge.xiwang.com/#/schoolDiagnose',
  // 导出pdf服务
  exportPdfDomain: 'https://pdf-export.xue.xiwang.com/',
  // 公告链接
  gongGaoJsonUrl:
    'https://m.xiwang.com/resource/__private__/4f229bfbfc600c39aa9811e209265b72/%E5%B8%8C%E6%9C%9B%E5%AD%A6%E7%B4%A0%E5%85%BB%E6%95%99%E5%B8%88%E5%B7%A5%E4%BD%9C%E5%8F%B0.json'
};

const XwykConfig = {
  appid: 'A1597771356',
  haichuanDomain: 'https://xuefuta.xue.wen-su.com/',
  // 学业诊断报告链接
  diagnosticReportHost: 'https://knowledge.wen-su.com/school-diagnose/#/DiagnosisReport',
  // 学业诊断报告-编辑页面
  diagnosticReportEditHost: 'https://knowledge.wen-su.com/#/schoolDiagnose',
  // 导出pdf服务
  exportPdfDomain: 'https://pdf-export.xue.wen-su.com/',
  // 公告链接
  gongGaoJsonUrl:
    'https://m.xiwang.com/resource/__private__/4f229bfbfc600c39aa9811e209265b72/%E5%B8%8C%E6%9C%9B%E5%AD%A6%E7%B4%A0%E5%85%BB%E6%95%99%E5%B8%88%E5%B7%A5%E4%BD%9C%E5%8F%B0.json'
};

const getConfig = () => {
  if (isXwx) {
    return XwxConfig;
  }
  if (isXwsy) {
    return XwsyConfig;
  }
  if (isXwyk) {
    return XwykConfig;
  }
  return XwxConfig;
};

const brandProdConfig = getConfig();
export default brandProdConfig;
